import { render, staticRenderFns } from "./ActionButton.vue?vue&type=template&id=c0dac476&scoped=true&"
import script from "./ActionButton.vue?vue&type=script&lang=ts&"
export * from "./ActionButton.vue?vue&type=script&lang=ts&"
import style0 from "./ActionButton.vue?vue&type=style&index=0&id=c0dac476&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dac476",
  null
  
)

export default component.exports